
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/survey/registration",
      function () {
        return require("private-next-pages/survey/registration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/survey/registration"])
      });
    }
  